import React from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthenticatedMutation } from "components/Auth/AuthenticatedQueryProvider";
import { Environment, Project } from "types/api";
import { useAdminRole, useUserRole } from "hooks/useRoleCheck";
import style from "../style.module.css";

interface ActionsProps {
  env: Environment;
  project: Project;
  providerClick: () => void;
}

const Actions: React.FC<ActionsProps> = ({ env, project, providerClick }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id, privileged } = env;
  const isAdmin = useAdminRole();
  const isUser = useUserRole();

  const archiveEnvironment = useAuthenticatedMutation<void, void>(
    `environments/${id}/archive`,
    {
      requiresTenant: true,
      method: "POST",
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [`projects/${project.id}`],
        });
      },
    }
  );

  return (
    <div className={style.actions} data-cy="environment-actions">
      {env.id && isAdmin && (
        <button
          type="button"
          className="material-icons"
          onClick={providerClick}
          data-tip="Edit Deployment Configuration"
          aria-label="Edit Deployment Configuration"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
        >
          code
        </button>
      )}

      {(privileged ? isAdmin : isUser) && (
        <button
          type="button"
          className="material-icons"
          onClick={() => navigate(`../../environments/${id}/edit`)}
          data-tip="Edit environment"
          aria-label="Edit environment"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
        >
          edit
        </button>
      )}

      {isAdmin && (
        <button
          type="button"
          className={`material-icons ${style.archiveButton}`}
          onClick={() => archiveEnvironment.mutate()}
          data-tip="Archive environment"
          aria-label="Archive environment"
          disabled={archiveEnvironment.isPending}
          style={{
            cursor: archiveEnvironment.isPending ? "wait" : "pointer",
            background: 'none',
            border: 'none',
            padding: '4px'
          }}
        >
          archive
        </button>
      )}
    </div>
  );
};

export default Actions;
